import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/index';



ReactDOM.render(
    <App />,  
    document.getElementById('myApp')
);


